export default class en {
	static translations = {
		labels: {
			logout: "Logout",
			profile: "Profile",
			rowsPerPage: "Rows per page:",
			all: "All",
			noResults: "No results.",
			of: "of",
			selectItem: "Select item",
			from: 'from',
			to: 'to',
			uploadInProgress: 'Upload in progress.'
		},
		modules: {
			login: "Login",
			dashboard: "Dashboard",
			profile: "My profile"
		},
		fields: {
			first_name: 'First name',
			last_name: 'Last name',
			name: 'Name',
			oib: 'OIB',
			iban: 'IBAN',
			email: 'E-mail',
			address: 'Address',
			city: 'City',
			postalCode: 'Postal code',
			country: 'Country',
			password: 'Password',
			rememberMe: 'Remember me',
			passwordConfirmation: 'Password repeated',
			passwordChange: "Password change",
			oldPassword: "Old password",
			newPassword: "New password",
			newPasswordConfirmation: "Repeated new passsword"
		},
		alerts: {
			deletionQuestion: "Are you sure that you want to delete this record?",
			fileDeletionQuestion: "Are you sure that you want to delete this file?",
			passwordMissing: "You did not enter password.",
			passwordFailConfirmation: "Passwords do not match.",
			passwordResetSuccess: "New password was sent to entered e-mail address.",
			passwordResetFail: "New users were found with entered e-mail address.",
			basicUpdate: "Changes saved.",
			basicDelete: "Record deleted.",
			basicAdd: "Record added.",
			basicError: "There was an error on the server."
		},
		buttons: {
			login: 'Login',
			logout: 'Logout',
			profile: 'My profile',
			new: "New",
			save: "Save",
			add: "Add",
			cancel: "Cancel",
			yes: "Yes",
			no: "No",
			ok: "OK",
			all: "All",
			delete: "Delete",
			back: "Back",
			forgottenPassword: "Forgotten password?"
		},
		texts: {

		},
		tooltips: {
		}
	}
}

